//
//
//
//
//
//

import { Quiz } from "@/models";
import QuizItem from "@/components/quiz/QuizItem.vue";

export default {
  name: "Quizs",
  created() {
    this.getData();
  },
  scrollBottom() {
    // this.getData(this.page + 1);
  },
  metaInfo() {
    return {
      title: "诗词测验"
    };
  },
  props: [],
  data() {
    return {
      quizs: [],
      page: 1,
      loading: false
    };
  },
  methods: {
    getData(page = 1) {
      this.loading = true;

      // 此接口调用有问题
      // 向下滚动的时候 （scroll）会不断取值
      // 但是目前quiz只有十条，取到重复的quiz，
      // 因为key是quiz.id, 会造成item的渲染错误
      Quiz.getAll(page)
        .then(quizs => {
          if (page == 1) {
            quizs.forEach(quiz => quiz.set('title', '中南大学 · ' + quiz.get('title').substring(2)))

            this.quizs = quizs;
          } else {
            this.quizs = this.quizs.concat(quizs);
          }

          this.loading = false;
          this.page = page;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  components: {
    QuizItem
  }
};



// WEBPACK FOOTER //
// ./src/pages/layouts/csu-pages/quiz/Quizs.vue